import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatchEvent } from '../../../models';

@Component({
  selector: 'edit-code-event-dialog',
  templateUrl: './edit-code-event.component.html',
  styleUrls: ['./edit-code-event.component.css']
})
export class EditCodeEventDialog implements OnInit {
  isLinear = true;
  propertiesFormGroup: FormGroup;

  constructor(
    private _fb: FormBuilder,
    public dialogRef: MatDialogRef<EditCodeEventDialog>,
    @Inject(MAT_DIALOG_DATA) public data: MatchEvent
  ) {}

  ngOnInit(): void {
    console.info('Editing: ', this.data);
    // this.propertiesFormGroup = this._fb.group(this.data.properties);
  }

  onSaveClick(): void {
    // this.data.seconds = this.data.seconds + 120;
    this.dialogRef.close(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
